import { atomWithStorage } from 'jotai/utils'
import { createStringStorage } from './generics'

export type UploadSortPreference = 'latest' | 'failed' | 'completed'

const stringStorage = createStringStorage<UploadSortPreference>()

export const uploadSortPreferenceAtom = atomWithStorage<UploadSortPreference>(
  'uploadSortPreference',
  'latest',
  stringStorage
)
